import CreatableSelect from 'react-select/creatable';
import { selectStyle, selectTheme } from '../../app/MACRA_2/components/InputForm/styles';
import { StylesConfig } from 'react-select';
import { EStepRatio } from '../../app/MACRA_2/components/graphicalResults/crossSection/steppedWeir/ISteppedWeir';
import { useState } from 'react';

export interface IOption {
    value: EStepRatio | number | string;
    label: string;
}
interface ISelectCreateProps {
    styles?: StylesConfig;
    theme?: (theme: any) => any;
    defaultValue?: string | number;
    value?: string | number;
    name: string;
    options: any[];
    disabled?: boolean;
    parentOnChange: (newValue: any) => void;
}

export const SelectCreate = (props: ISelectCreateProps) => {
    const [error, setError] = useState<string>('');

    const { styles, theme, defaultValue, value, name, options, disabled, parentOnChange } = props;

    return (
        <div className='d-flex flex-column align-items-end'>
            <CreatableSelect
                styles={styles ?? selectStyle}
                theme={theme ?? selectTheme}
                value={{ label: defaultValue?.toString().replace('.', ',') || value?.toString().replace('.', ','), value: defaultValue || value }}
                name={name}
                options={options}
                isDisabled={disabled}
                onChange={(newValue: any) => {
                    if (isNaN(parseFloat(newValue.value))) {
                        setError('Carattere non valido');
                    } else {
                        setError('');
                        if (newValue.value.toString().includes(',')) parentOnChange(parseFloat(newValue.value.replace(',', '.')));
                        else {
                            parentOnChange(parseFloat(newValue.value));
                        }
                    }
                }}
            />
            {!!error && <span className='error-color'>{error}</span>}
        </div>
    );
};
